import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

// `align` controls the alignment of the title + subtitle only (default 'left',
// matching every existing auth page). The success state of the request-access
// page passes 'center' (#350).
export default function AuthCard({ title, subtitle, children, align = 'left' }) {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default', px: { xs: 2, sm: 0 } }}>
      <Paper elevation={0} sx={{ width: '100%', maxWidth: 420, p: { xs: 3, sm: 4 }, borderRadius: '6px' }}>
        <Typography variant="h5" fontWeight={700} mb={0.5} color="text.primary" textAlign={align}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" mb={3} textAlign={align}>
            {subtitle}
          </Typography>
        )}
        {children}
      </Paper>
    </Box>
  );
}
